import React, { PropsWithChildren } from 'react';
import { ActionsBar, Button, Column } from '@ydistri/ds';
import { styled } from 'styled-components';
import { computeRemSize } from '@ydistri/theme';

interface EntityListFiltersProps extends PropsWithChildren {
  closePopover: () => void;
  resetFilters?: () => void;
  filterSet?: boolean;
}

const FiltersColumn = styled(Column)`
  min-width: ${() => computeRemSize(400)};
`;

/**
 * A wrapper for the content of a filters popover.
 * It displays the children and a Close button at the bottom.
 * This component is used in conjunction with PopupFiltersAction as the content of the popover.
 * @param closePopover
 * @param resetFilters - Optional reset filters function. If provided, a "Reset filters" button is shown.
 * @param filterSet - Whether some filters are applied or not. If true, the "Reset filters" button is enabled.
 * @param children
 * @constructor
 */
const PopupFiltersWrapper: React.FC<EntityListFiltersProps> = ({
  closePopover,
  resetFilters,
  filterSet = false,
  children,
}) => {
  return (
    <FiltersColumn $gap="2rem" $padding={1} $flexGrow={1}>
      {children}
      <ActionsBar moveToRight>
        {resetFilters && (
          <Button onClick={resetFilters} disabled={!filterSet} $colorVariant="ghost">
            Reset filters
          </Button>
        )}
        <Button onClick={closePopover}>Close</Button>
      </ActionsBar>
    </FiltersColumn>
  );
};

export default PopupFiltersWrapper;
